import type { IFont } from '@/typescript/interfaces/IFont';

export default async function checkFont(fontFamily: string | undefined, fontFaces: IFont[]): Promise<void> {
    const font = fontFaces.find((currentFont) => currentFont.fontFace.family === fontFamily);
    if (!font) {
        return;
    }
    if (!document.fonts.check(`12px ${fontFamily}`)) {
        await font.fontFace.load();
    }
}
